import React from 'react';
import { components } from 'react-select';
import classnames from 'classnames';

const MultiValue = (props) => {
  const disabledClass = `${props.selectProps.classNamePrefix}__multi-value_disabled`;

  return (
    <components.MultiValue
      {...props}
      className={classnames({
        [disabledClass]: props.selectProps.isOptionDisabled(props.data),
      })}
    />);
};

export default MultiValue;
